/**
 * 格式化工具
 */

import { formatBrtDate, formatBrtDateTime } from './timezone'

/**
 * 格式化日期显示 MM/DD/YYYY（巴西利亚时区）
 */
export function formatDate(dateStr) {
  return formatBrtDate(dateStr)
}

/**
 * 格式化金额 (BRL)
 */
export function formatCurrency(value) {
  if (value == null || value === '') return '-'
  const num = typeof value === 'string' ? parseFloat(value) : value
  if (isNaN(num)) return '-'
  return 'R$ ' + num.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}

/**
 * 格式化金额 (CNY - 人民币)
 */
export function formatCurrencyCNY(value) {
  if (value == null || value === '') return '-'
  const num = typeof value === 'string' ? parseFloat(value) : value
  if (isNaN(num)) return '-'
  // return '¥ ' + num.toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
  return num.toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' CNY'
}

/**
 * 格式化日期时间 MM/DD/YYYY HH:mm（巴西利亚时区）
 */
export function formatDateTime(dateStr) {
  return formatBrtDateTime(dateStr)
}

/**
 * 生成唯一ID
 */
let idCounter = 0
export function generateId() {
  idCounter++
  return 'SH' + Date.now().toString(36).toUpperCase() + idCounter.toString().padStart(4, '0')
}

/**
 * 状态中文映射
 */
export function statusLabel(status) {
  const map = {
    shipping: '已启运',
    arrived: '已到港',
    pending_delivery: '待派送',
    warehouse: '海外仓处理',
    completed: '已完结'
  }
  return map[status] || status
}

/**
 * 状态CSS类名
 */
export function statusClass(status) {
  return status || ''
}
